import { useEffect } from "react";

export const OPEN_MESSENGER_EVENT = "unread:open-messenger";

/** Команда плашки «открыть мессенджер» (её слушает MainLayout). */
export const requestOpenMessenger = () =>
  window.dispatchEvent(new CustomEvent(OPEN_MESSENGER_EVENT));

/**
 * Подключает команды плашки к состоянию MainLayout.
 * @param {{ setMessengerOpen: (open: boolean) => void }} handlers
 */
export default function useUnreadCommands({ setMessengerOpen }) {
  useEffect(() => {
    const openMessenger = () => setMessengerOpen(true);
    window.addEventListener(OPEN_MESSENGER_EVENT, openMessenger);
    return () => window.removeEventListener(OPEN_MESSENGER_EVENT, openMessenger);
  }, [setMessengerOpen]);
}
